<template>
  <div>
    <v-btn style="margin: 16px;" color="primary" rounded @click="getReport">
      {{ "وضعیت در یک نگاه" }}
    </v-btn>
    <v-card>
      <!-- <div class="userinfo">
        <div class="avatar" :style="{ 'background-image': ImageUrl }"></div>
        <div
          class="textinfo"
          :style="{
            padding: userInfo.Active ? '35px 10px' : '60px 10px 35px 10px',
          }"
        >
          <div class="fullname">{{ fullName }}</div>
          <div v-if="userInfo.Active">{{ NumSystem }}</div>
        </div>
      </div> -->
      <div v-if="userInfo.Active" class="userdetail">
        <app-row icon="hashtag" title="کد طلبگی:" :value="userInfo.Num_System" />
        <app-row icon="home" title="مدرسه:" :value="userInfo.School" />
        <app-row icon="address-card" title="سطح و پایه:" :value="`${userInfo.Sath}، ${userInfo.Payeh}`" />
        <!-- <app-row icon="book" title="پایه:" :value="userInfo.Payeh" /> -->
        <app-row icon="money-bill" title="وضعیت شهریه:" :value="userInfo.StrShahrieh" />
        <app-row icon="quran" title="وضعیت تلبس:" :value="userInfo.Talabbos" />
        <app-row icon="heart" title="وضعیت تاهل:" :value="userInfo.Tahol" />
        <app-row icon="flag" title="وضعيت نظام وظيفه:" :value="userInfo.NezamState" />
        <app-row icon="phone" title="تلفن همراه:" :value="userInfo.Mobile" link="https://profile.hozehkh.com" />
        <app-row icon="building" title="نشانی منزل:" :value="userInfo.HomeAddress" link="https://profile.hozehkh.com" />
        <app-row icon="envelope" title="پیام های خوانده نشده:" :value="UnreadMessagesCount" />

      </div>
    </v-card>
    <v-card>
      <!-- <div class="userinfo">
        <div class="avatar" :style="{ 'background-image': ImageUrl }"></div>
        <div
          class="textinfo"
          :style="{
            padding: userInfo.Active ? '35px 10px' : '60px 10px 35px 10px',
          }"
        >
          <div class="fullname">{{ fullName }}</div>
          <div v-if="userInfo.Active">{{ NumSystem }}</div>
        </div>
      </div> -->
      <div class="userdetail">
        <app-row icon="university" title="شأن تحصیلی:" :value="userInfo.TahsilState" />
        <app-row icon="file" title="پیشرفت تحصیلی:"
          :value="`${userInfo.TahsilPishraft}${userInfo.TahsilTaraz > 0 ? ' تراز: ' + userInfo.TahsilTaraz : ''}`" />
        <app-row icon="chalkboard-teacher" title="شأن تدریس:" :value="userInfo.TadrisState" />
        <app-row icon="child" title="شأن تبلیغ:" :value="userInfo.TablighState" />
        <app-row icon="file-word" title="شأن پژوهش:" :value="userInfo.PajooheshState" />
        <div style="margin: 25px;"><b>توجه: </b>موارد فوق صرفا براساس اطلاعات مرکز مدیریت خراسان می باشد و عینا در
          اختیار
          مرکز خدمات و دفتر وجوهات رهبری (سامانه امین) قرار دارد.</div>

      </div>
    </v-card>
    <v-card>
      <!-- <div class="userinfo">
        <div class="avatar" :style="{ 'background-image': ImageUrl }"></div>
        <div
          class="textinfo"
          :style="{
            padding: userInfo.Active ? '35px 10px' : '60px 10px 35px 10px',
          }"
        >
          <div class="fullname">{{ fullName }}</div>
          <div v-if="userInfo.Active">{{ NumSystem }}</div>
        </div>
      </div> -->
      <div v-if="userInfo.IsargaryType != ''" class="userdetail">
        <app-row icon="" title="وضعیت ایثارگری:" :value="userInfo.IsargaryState" />
        <app-row icon="" title="نوع ایثارگری :" :value="userInfo.IsargaryType" />
        <app-row icon="" title="مدت حضور در جبهه به ماه:" :value="userInfo.IsargaryTime" />

      </div>
    </v-card>

    <!-- <v-card style="cursor: pointer" @click="$router.push('/messages')">
      <div class="userdetail">
        
      </div>
    </v-card> -->

    <!-- <app-social></app-social> -->
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { getUserReport } from "@/api/user";
import { saveByteArray } from "@/utils/constants";


export default {
  components: {
    appRow: DetailRow,
  },
  data() {
    return {
      // selectedMenu: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },

    UnreadMessagesCount() {
      return this.$store.getters.UnreadMessagesCount + " پیام";
    },
  },
  methods: {
    getReport() {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      getUserReport()
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  }
};
</script>
<style scoped>
.addressButton {
  width: unset;
  margin-top: 50px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.v-icon {
  margin: 0 !important;
  font-size: 16px;
}

.v-item--active {
  background: rgb(33, 118, 208) !important;
  background: linear-gradient(180deg,
      rgba(33, 118, 208, 1) 0%,
      rgba(33, 118, 208, 1) 35%,
      rgba(12, 50, 91, 1) 100%) !important;
  color: white !important;
}

.userdetail {
  padding: 15px 0
}
</style>
